import { render } from "./ServiceDetails6Page.vue?vue&type=template&id=47b4e1d3&ts=true"
import script from "./ServiceDetails6Page.vue?vue&type=script&lang=ts"
export * from "./ServiceDetails6Page.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__